import { createStore } from 'vuex';

const store = createStore({
  state: {
    count: 0,
    screenWidth:0,
    screenHeight:0,
  },
  getters: {
    doubleCount: (state) => state.count * 2
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    screenWH(state,date){
        // console.log('stor',date);

        state.screenWidth = date.w
        state.screenHeight = date.h
        // console.log('stor',state.screenWidth ,state.screenHeight);
    }

  },
  actions: {
    incrementIfOdd({ state, commit }) {
      if (state.count % 2 !== 0) {
        commit('increment');
      }
    }
  }
});

export default store;
